<script lang="ts" setup>
	import Sidebar from './partials/sidebar/sidebar.vue';
	import Header from './partials/header.vue';
	import Toaster from '@/components/ui/toast/Toaster.vue';
	import {SidebarProvider, SidebarInset} from '@/views/components/ui/sidebar';
	import {useAuthentication} from '@/scripts/composables/use-authentication.ts';
	import {useFlashMessages} from '@/scripts/composables/use-flash-messages';
	import {Head, usePage} from '@inertiajs/vue3';

	const {isAuthenticated} = useAuthentication();

	import Favicon from '@/images/ProzessWunder_Icon.png';

	// Initialize flash messages and page props
	useFlashMessages();
	const page = usePage();
</script>

<template>
	<Toaster />

	<!-- Setup document head -->
	<Head>
		<link
			:href="page.props.icon ?? Favicon"
			rel="icon"
		/>
		<title>ProzessWunder</title>
	</Head>

	<SidebarProvider :default-open="isAuthenticated">
		<Sidebar />
		<SidebarInset>
			<Header />
			<div class="flex flex-1 flex-col gap-4 p-4 pt-0">
				<slot />
			</div>
		</SidebarInset>

		<!-- Cookie Consent Components -->
		<CookieConsentBanner />
		<CookieSettingsModal />
	</SidebarProvider>
</template>
